import {FilterMetadataMap, FromFilterDefinition, NonNullableFilterValues, NullableFilterValues,} from "../filtering";
import {SortSelectionObject} from "../common";

export const ASSET_SORT_COLUMNS = {
    assetId: 'assetId',
    deliveryEta: 'deliveryEta',
    deliveredAt: 'deliveredAt',
} as const;

export const ASSET_DEFAULT_SORT: SortSelectionObject<typeof ASSET_SORT_COLUMNS> = {column: 'assetId', direction: 'desc'}

export const ASSET_FILTER_DEFINITION = {
    search: 'string',
    state: 'string[]',
    status: 'string[]',
    type: 'string[]',
    locationType: 'string[]',
    carrier: 'string[]',
    deliveryEta: 'DateFilter',
    deliveredAt: 'DateFilter'
} as const;

export const ASSET_STATE_VALUES = ['ACTIVE', 'LOST', 'RETIRED'] as const;

export const ASSET_STATUS_VALUES = [
    'PENDING', 'IN_TRANSIT', 'ISSUE', 'DELIVERED', 'RECEIVED'
] as const;

export const ASSET_TYPE_VALUES = ['LAPTOP'] as const;

export const ASSET_LOCATION_TYPE_VALUES = [
    'Warehouse',
    'JobSite',
    'Technician',
] as const;


export const ASSET_SHIPPING_CARRIER_VALUES = [
    'UPS',
    'FedEx',
] as const;

export const ASSET_FILTER_METADATA = {
    state: {
        kind: 'enum' as const,
        enumValues: ASSET_STATE_VALUES,
        isArray: true
    },
    status: {
        kind: 'enum' as const,
        enumValues: ASSET_STATUS_VALUES,
        isArray: true,
    },
    type: {
        kind: 'enum' as const,
        enumValues: ASSET_TYPE_VALUES,
        isArray: true
    },
    locationType: {
        kind: 'enum' as const,
        enumValues: ASSET_LOCATION_TYPE_VALUES,
        isArray: true,
    },
    carrier: {
        kind: 'enum' as const,
        enumValues: ASSET_SHIPPING_CARRIER_VALUES,
        isArray: true,
    },
} as const satisfies FilterMetadataMap<typeof ASSET_FILTER_DEFINITION>;

export type AssetFilterDefinition = FromFilterDefinition<typeof ASSET_FILTER_DEFINITION>

export type NullableAssetFilter = NullableFilterValues<AssetFilterDefinition>;
export type NonNullableAssetFilter =
    NonNullableFilterValues<AssetFilterDefinition>;

export const DEFAULT_ASSET_FILTER: NullableAssetFilter = {
    search: null,
    state: null,
    status: null,
    type: null,
    locationType: null,
    carrier: null,
    deliveryEta: null,
    deliveredAt: null
};
